import { fetchcrearArticulo, fetcheditarArticulo, fetchExtraerArticulo, traerTodosLosArticulos, traerTodosLosArticulosSegunGrupo } from "./Api_Articulos_Providers";

export const obtenerListaArticulos = (estado) => {
    return async () => {
        try {
            // Llama a la función para obtener la lista de artículos
            const resultado = await traerTodosLosArticulos({ estado });
            // Devuelve el primer elemento de la respuesta (asumiendo que es un array)
            return resultado.data.data;
        } catch (error) {
            console.error("Error al obtener la lista de artículos:", error);
        }
    };
};

export const obtenerListaArticulosSegunGrupo = (estado, grupo) => {
    return async () => {
        try {
            // Llama a la función para obtener la lista de artículos
            const resultado = await traerTodosLosArticulosSegunGrupo({ estado, grupo });
            // Devuelve el primer elemento de la respuesta (asumiendo que es un array)
            return resultado.data.data;
        } catch (error) {
            console.error("Error al obtener la lista de artículos:", error);
        }
    };
};



/**
 * Crea un nuevo artículo utilizando los datos proporcionados.
 *
 * @param {Object} formData - Los datos del formulario para crear el artículo.
 * @returns {Function} Una función thunk que retorna una Promesa con los detalles del artículo creado.
 */
export const crearArticulo = (formData) => {
    return async () => {
        try {
            // Llama a la API para crear un nuevo artículo con los datos proporcionados.
            const resultado = await fetchcrearArticulo({ formData });
            // Devuelve los datos del primer registro encontrado en la respuesta.
            return resultado.data.data["0"];
        } catch (error) {
            console.error("Error al crear el artículo:", error);
        }
    };
};



export const EditarArticu = (formData) => {
    return async () => {
        try {
            // Llama a la API para crear un nuevo artículo con los datos proporcionados.
            const resultado = await fetcheditarArticulo({ formData });
            // Devuelve los datos del primer registro encontrado en la respuesta.
            return resultado.data.data["0"];
        } catch (error) {
            console.error("Error al crear el artículo:", error);
        }
    };
};

export const ExtraerArticulo = (idArticulo) => {
    return async () => {
        try {
            // Llama a la API para extraer información del artículo con el ID proporcionado.
            const resultado = await fetchExtraerArticulo({ idArticulo });
            // Retorna los datos del primer registro encontrado en la respuesta.
            return resultado.data.data["0"];
        } catch (error) {
            // Maneja cualquier error ocurrido durante la solicitud a la API.
            console.error("Error al extraer el artículo:", error);
        }
    };
};


